import React, {useContext, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {SignupFeatures} from '../../components/signup-features';
import {LoginForm, LoginFormData} from '../../components/login-form';
import {Grid} from '../../components/layout';
import {AccountRegistrationContext} from '../../contexts/account-registration.provider';
import {AccountServiceImpl} from '../../services';
import {ROUTES} from '../../constants/routes';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const {resendVerificationEmail} = useContext(AccountRegistrationContext);
  const accountService = useMemo(() => new AccountServiceImpl(), []);

  const findAccountByEmail = async (email: string): Promise<{accountId: string} | null> => {
    try {
      const searchResponse = await accountService.search([{email}]);

      if (searchResponse.data && searchResponse.data.length > 0) {
        const result = searchResponse.data[0];
        if (result.account && result.account.id) {
          return {accountId: result.account.id};
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const handleSubmit = async (values: LoginFormData, actions: any): Promise<void> => {
    try {
      const accountResult = await findAccountByEmail(values.email);

      if (!accountResult) {
        actions.setStatus('No account found with this email address. Please sign up first.');
        return;
      }

      const verificationResult = await resendVerificationEmail(accountResult.accountId);

      if (!verificationResult.data) {
        throw new Error(verificationResult.error || 'Failed to send verification email');
      }

      navigate(ROUTES.VERIFY_EMAIL, {
        state: {
          email: values.email,
          accountId: accountResult.accountId,
          isLogin: true,
        },
      });
    } catch (error: any) {
      actions.setStatus(error.message || 'Failed to send login link. Please try again.');
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Grid cols={{sm: 1, lg: 2}}>
      <SignupFeatures />
      <LoginForm onSubmit={handleSubmit} />
    </Grid>
  );
};
